import { useState } from "react";
import KundeNeu from "../KundeNeu";
import { VertragsartWahl } from "./teile";
import type { KundeLite } from "../../lib/wizard";

/** Schritt 1 „Kunde": suchen oder neu anlegen, dann Privatperson oder Firma. */
export default function SchrittKunde({ chosen, gesperrt, onWechseln, suche, setSuche, sucheFertig, treffer, onWaehlen, vertragsart, setVertragsart, fehler }: {
  chosen: KundeLite | undefined;
  gesperrt: boolean;
  onWechseln: () => void;
  suche: string;
  setSuche: (s: string) => void;
  /** Die Serversuche hat den aktuellen Text schon beantwortet. */
  sucheFertig: boolean;
  treffer: KundeLite[];
  onWaehlen: (id: string) => void;
  vertragsart: string;
  setVertragsart: (v: string) => void;
  fehler: string;
}) {
  const [neuerKunde, setNeuerKunde] = useState(false);

  return (
    <>
      {chosen ? (
        <div className="pf-card pf-wz-abstand">
          <div className="pf-wz-titel">{chosen.name}</div>
          <div className="pf-wz-text-3">{chosen.adresse || chosen.ort}</div>
          {gesperrt ? (
            <div className="pf-wz-klein pf-wz-oben-8">
              Der Kunde steht fest — für einen anderen Garten braucht es einen eigenen Vertrag.
            </div>
          ) : (
            <button className="pf-btn is-ghost is-small pf-wz-oben-10" onClick={onWechseln}>
              Anderen Kunden wählen
            </button>
          )}
        </div>
      ) : (
        <>
          <div className="pf-wz-suche">
            <input className="pf-input pf-wz-wachsen" placeholder="Kunde suchen…" value={suche} onChange={e => setSuche(e.target.value)} />
            {/* Oben, nicht unter 40 Treffern (Abnahme 09.10.2026). */}
            {!neuerKunde && (
              <button className="pf-btn is-ghost is-small pf-wz-nowrap" onClick={() => setNeuerKunde(true)}>＋ Neuer Kunde</button>
            )}
          </div>
          {neuerKunde && (
            <KundeNeu vorschlag={suche} onAbbrechen={() => setNeuerKunde(false)}
              onAngelegt={id => { setNeuerKunde(false); setSuche(""); onWaehlen(id); }} />
          )}
          <div className="pf-wz-oben-10">
            {!neuerKunde && treffer.map(k => (
              <button key={k.id} className="pf-row" onClick={() => onWaehlen(k.id)}>
                <div className="pf-row-main pf-wz-links">
                  <div className="pf-wz-fett">{k.name}</div>
                  <div className="pf-wz-klein">{k.adresse || k.ort}</div>
                </div>
              </button>
            ))}
            {suche.trim() && sucheFertig && treffer.length === 0 && !neuerKunde && (
              <div className="pf-wz-keiner">Kein Kunde „{suche.trim()}" gefunden.</div>
            )}
          </div>
        </>
      )}
      {chosen && <VertragsartWahl wert={vertragsart} onWahl={setVertragsart} />}
      {fehler && <div className="pf-wz-fehler pf-wz-oben-10">{fehler}</div>}
    </>
  );
}
